"use strict";

class StationSettingsApiPushCtrl {

    constructor($rootScope, $http, $scope, $mdToast, $mdDialog) {
        this.$rootScope = $rootScope;

        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;

        this.settings = {};
        this.tokens = {};

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        $scope.$watch(() => {
            return $scope.pushsettings.$invalid;
        }, (newVal) => {
            $rootScope.saveDisabled = newVal;
        });

        //this.$rootScope.saveHiden = true;
    }


    fetch() {
        this.$http.get('/stationsettings/settings').then(response => {
            this.settings = response.data;
        });

        this.$http.get('/tokens').then(response => {

            this.tokens = response.data;
        });
    }


    save() {
        this.$http.put('/stationsettings/settings', this.settings)
            .then(() => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object=Push_credentials',
                    hideDelay: 6000,
                    position: ('top right')
                });
            });
    }


    apiKeyDelete(id, $index, ev) {

        ev.stopPropagation();

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true
        }).then(() => {

            this.$http.delete('/tokens/' + id).then(() => {

                this.tokens.splice($index, 1);
            });
        });
    }


    openSyncDialog() {

        this.$mdDialog.show({
            controller: 'SyncDialogCtrl',
            templateUrl: 'apiSyncDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
        });
    }


    test() {
        console.log(test)
    }


    createOrUpdateApiKey(tokenIndex, tokenId) {

        this.$mdDialog.show({
            controller: 'ApiDialogCtrl',
            templateUrl: 'apiKeyDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
            locals: {

                tokenId: tokenId,
                tokenIndex: tokenIndex,
                tokens: this.tokens
            }
        }).then(function () {

        }, (remove) => {

            if (remove != null) {

                this.$http.delete('/tokens/' + remove);
            }

        });
    }
}

StationSettingsApiPushCtrl.$inject = [
    '$rootScope',
    '$http',
    '$scope',
    '$mdToast',
    '$mdDialog'
];

module.exports = StationSettingsApiPushCtrl;